import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, catchError } from 'rxjs';

import { AppSettingsService } from './app-settings.service';
import { buildLoginAppUrl } from './app/shared/auth/login-app-url';
import { LoginRedirectService } from './app/shared/auth/login-redirect.service';

@Injectable({ providedIn: 'root' })
export class AppInterceptors {
  static basicInterceptor(this: void, req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const appSettingsService = inject(AppSettingsService);
    const loginRedirect = inject(LoginRedirectService);
    const headers = req.headers;
    const clonedRequest = req.clone({
      headers,
      withCredentials: true,
    });
    return next(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const loginUrl = appSettingsService.appConfig?.LOGIN_APP_FE_URL?.trim();
          if (loginUrl) {
            loginRedirect.redirectTo(
              buildLoginAppUrl(loginUrl, window.location.href, appSettingsService.appConfig?.MTP_APPLICATION_CODE),
            );
          }
        }

        throw error as Error;
      }),
    );
  }
}
